import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  GET,
  POST,
} from '@app/core/api';
import {XmaTextEmojifyDto, XmaTextGenerationDto} from '@app/core/dto';
import type {XmaBusinessProfileResult} from '@app/core/interfaces/xma-business-profile-result.interface';

@ApiController('api/app/xma')
@Injectable({
  providedIn: 'root',
})
export class XmaApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @POST('/text-emojify')
  textEmojify(@Body() dto: XmaTextEmojifyDto): Observable<ApiResponse<string>> {
    return {} as Observable<ApiResponse<string>>;
  }

  @POST('/text-generation')
  textGeneration(@Body() dto: XmaTextGenerationDto): Observable<ApiResponse<string>> {
    return {} as Observable<ApiResponse<string>>;
  }

  @GET('/text-generation/business-profile')
  getBusinessProfile(): Observable<ApiResponse<XmaBusinessProfileResult>> {
    return {} as Observable<ApiResponse<XmaBusinessProfileResult>>;
  }
}
